export const isEnglish = (content) => {
  if (!content) return false;

  let text = '';
  if (typeof content === 'string') {
    text = content;
    // Check if it's a JSON string of Draft.js
    if (text.trim().startsWith('{') && text.includes('"blocks"')) {
      try {
        const parsed = JSON.parse(text);
        if (parsed.blocks) {
          text = parsed.blocks.map((block) => block.text).join(' ');
        }
      } catch (e) {
        // Not a valid JSON or not Draft.js
      }
    }
  } else if (typeof content === 'object' && content.blocks) {
    // Draft.js state object
    text = content.blocks.map((block) => block.text).join(' ');
  } else {
    // For other object types, we don't safely know which field to check
    // Return false to default to RTL (Arabic) as per app's primary language
    return false;
  }

  // Regex to detect Arabic characters
  const hasArabic = /[\u0600-\u06FF]/.test(text);
  if (hasArabic) {
    return false; // Arabic found, always default to RTL
  }

  // Regex to detect English characters
  return /[a-zA-Z]/.test(text);
};

export const getDirection = (content) => {
  return isEnglish(content) ? 'ltr' : 'rtl';
};

export const getDirClass = (content) => {
  return isEnglish(content) ? 'ltrtext' : 'rtltext';
};
